<template>
  <div class="button-contain" :class="{'-fieldpage' : isFieldPage,'-loginpage' : isloginpage }">
    <button :class="{'-login' : isloginpage}" :disabled="status.loading" @click="action">
      <span v-if="!status.loading">{{text}}</span>
      <div v-else class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </button>
    <div class="notification" v-if="status.message" :class="`-${status.type}`">
      <div class="notification__icon">
        <IconRequestError v-if="status.type == 'Error'" />
        <IconRequestSuccess v-if="status.type == 'Success'" />
      </div>
      <div class="notification__message">{{status.message}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null
    },
    status: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: true
    },
    isloginpage: {
      type: Boolean,
      default: false
    },
    isFieldPage: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    action: function() {
      this.$emit("action");
    }
  }
};
</script>

<style lang="scss" scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 48px;
  height: 48px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 38px;
  height: 38px;
  margin: 4px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>